import { requests } from '.'
import Token from '../models/Token.model';

export type AuthType = ''|'kakao'|'email'|'naver'|'google'

type SignUp = {
  type: AuthType
  name: string
  phone: string
  uid: string
  password?: string
  token?: string
  productId: number, 
  payMethod: number
  paymentData: any
}

export const AuthApi = {

  certification: (imp_uid: string, type: string) => requests.post<any>('v1/auth/certifications', {imp_uid, type}),

  getSocialInfo: (type: AuthType, token: string) => requests.post<{uid: string}>('v1/auth/social', {type, token}),
  
  signInSocial: (type: AuthType, uid: string) => 
  requests.post<Token>('v1/auth/token', {type, uid}),

  signInEmail: (uid: string, password: string) => requests.post<Token>('v1/auth/token', {type: 'email', uid, password}),
  checkUid: (uid: string) => requests.post<any>(`v1/auth/check-uid`, {uid}),
  signUp: (data: SignUp) => requests.post<Token>('v1/auth/sign-up', data),
  findId: (imp_uid: string) => requests.post<any>('v1/auth/find-id', {imp_uid}),
  resetPassword: (password: string) => requests.post<any>(`v1/auth/reset-password`, {password}),

};